import React, { Component } from "react";
//import '../styleSheets/App.css';
import Header from "./MainHeader.js";
//import ScrollButton from "./ScrollButton.js";
//import Header from "./TempHeader.js"
//import FooterMain from "../FooterNew";
import MainHeaderCollapse from "./MainHeaderCollapse.js";
import { Container, Row, Col } from 'react-bootstrap';
/**
 * Common Layout for Home Page Compnents
 *  <Header/> <AnyCompnent></Footer>
 *
 */
class App extends Component {

  render() {
    return (
      // <AlertProvider template={AlertTemplate} {...options}
         <div>
         <Container fluid className="header_main" style={{backgroundColor:"#FFFFFF"}}>
          <Row>
            <Col>
              <div className="headermaindiv" >
                {/* Header content */}
                <MainHeaderCollapse />
              </div>
            </Col>
          </Row>
        </Container>
        

<Container fluid>
<Row>
  <Col>
    <div className="main" >
         {this.props.children}
         </div>
         
            </Col>
          </Row>
        </Container>
        </div>
        
    );
  }
}

export default App;
